'use client';
'use strict';

var React = require('react');
var useRecaptchaExecute = require('./useRecaptchaExecute.js');

function useFormieGRecaptcha(settings) {
    const { requestToken, ready } = useRecaptchaExecute();
    const getCaptchaValues = React.useCallback(async ()=>{
        if (!settings) return {};
        const { gRecaptchaEnabled, gRecaptchaName, gRecaptchaHandle } = settings;
        if (!ready || !gRecaptchaEnabled) return {};
        const token = await requestToken(gRecaptchaName);
        const newValue = {
            name: gRecaptchaName,
            value: token
        };
        const values = {
            [gRecaptchaHandle]: newValue
        };
        return values;
    }, [
        settings,
        ready,
        requestToken
    ]);
    return {
        ready,
        getCaptchaValues
    };
}

module.exports = useFormieGRecaptcha;
